export default "__VITE_ASSET__DF9SROyR__"